import { useState, useEffect, useRef, useMemo, useCallback } from "react";

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// DESIGN TOKENS
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
const T = {
    bg0: "#010b12", bg1: "#030f1a", bg2: "#051525", bg3: "#081e33", bg4: "#0c2440", bg5: "#102a4a",
    a: "#00e5a0", a2: "rgba(0,229,160,0.15)", a3: "rgba(0,229,160,0.07)",
    cy: "#00d4ff", cy2: "rgba(0,212,255,0.12)",
    am: "#ffb300", am2: "rgba(255,179,0,0.12)",
    rd: "#ff2d55", rd2: "rgba(255,45,85,0.14)",
    gr: "#00e676", gr2: "rgba(0,230,118,0.12)",
    ye: "#ffd740", ye2: "rgba(255,215,64,0.12)",
    pu: "#d05af2", pu2: "rgba(208,90,242,0.12)",
    or: "#ff6d00",
    pk: "#ff6eb4",
    tx: "#c8dde8", txL: "#8fb0c4", txD: "#4a7a95", txX: "#1e3a4f",
    br: "rgba(0,229,160,0.11)", brH: "rgba(0,229,160,0.30)",
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// VEDIC PANCHANG ENGINE
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
const NAKSHATRAS = [
    { name: "Ashwini", lord: "Ketu", type: "leaf", farm: "Planting roots, tubers" },
    { name: "Bharani", lord: "Venus", type: "fruit", farm: "Fruit crops, flowers" },
    { name: "Krittika", lord: "Sun", type: "root", farm: "Avoid sowing, cutting ok" },
    { name: "Rohini", lord: "Moon", type: "leaf", farm: "Best for ALL sowing ★★★" },
    { name: "Mrigashira", lord: "Mars", type: "flower", farm: "Herbs, flowers, spray" },
    { name: "Ardra", lord: "Rahu", type: "leaf", farm: "Avoid — destructive" },
    { name: "Punarvasu", lord: "Jupiter", type: "fruit", farm: "Good sowing, replanting" },
    { name: "Pushya", lord: "Saturn", type: "flower", farm: "BEST nakshatra for sowing ★★★" },
    { name: "Ashlesha", lord: "Mercury", type: "root", farm: "Avoid all operations" },
    { name: "Magha", lord: "Ketu", type: "root", farm: "Cutting, clearing land" },
    { name: "Purva Phalguni", lord: "Venus", type: "fruit", farm: "Flowers, fruit trees" },
    { name: "Uttara Phalguni", lord: "Sun", type: "leaf", farm: "All crops, very auspicious" },
    { name: "Hasta", lord: "Moon", type: "leaf", farm: "Excellent for sowing ★★★" },
    { name: "Chitra", lord: "Mars", type: "flower", farm: "Flowering, fruit planting" },
    { name: "Swati", lord: "Rahu", type: "flower", farm: "Spraying, pest control" },
    { name: "Vishakha", lord: "Jupiter", type: "fruit", farm: "Harvest, fruit picking" },
    { name: "Anuradha", lord: "Saturn", type: "flower", farm: "Sowing, planting seedlings" },
    { name: "Jyeshtha", lord: "Mercury", type: "root", farm: "Avoid sowing" },
    { name: "Moola", lord: "Ketu", type: "root", farm: "Root crops only, risky" },
    { name: "Purva Ashadha", lord: "Venus", type: "flower", farm: "Water plants, irrigation" },
    { name: "Uttara Ashadha", lord: "Sun", type: "root", farm: "Planting, root crops" },
    { name: "Shravana", lord: "Moon", type: "leaf", farm: "Best for water crops ★★" },
    { name: "Dhanishtha", lord: "Mars", type: "root", farm: "Avoid sowing, GC ok" },
    { name: "Shatabhisha", lord: "Rahu", type: "flower", farm: "Spraying medicines" },
    { name: "Purva Bhadra", lord: "Jupiter", type: "fruit", farm: "All purpose, moderate" },
    { name: "Uttara Bhadra", lord: "Saturn", type: "flower", farm: "Flowers, moderate sowing" },
    { name: "Revati", lord: "Mercury", type: "leaf", farm: "Excellent for SO ★★★" },
];

const TITHIS = [
    "Pratipada", "Dwitiya", "Tritiya", "Chaturthi", "Panchami",
    "Shashthi", "Saptami", "Ashtami", "Navami", "Dashami",
    "Ekadashi", "Dwadashi", "Trayodashi", "Chaturdashi", "Purnima/Amavasya"
];

const YOGAS = [
    { name: "Vishkambha", type: "bad", desc: "Obstacle yoga — avoid new missions" },
    { name: "Priti", type: "good", desc: "Love yoga — excellent for planting" },
    { name: "Ayushman", type: "good", desc: "Long life — good for perennials" },
    { name: "Saubhagya", type: "good", desc: "Fortune — best for sowing" },
    { name: "Shobhana", type: "good", desc: "Brilliant — all ops favorable" },
    { name: "Atiganda", type: "bad", desc: "Obstruction — avoid spraying" },
    { name: "Sukarma", type: "good", desc: "Good deeds — all ops ok" },
    { name: "Dhriti", type: "good", desc: "Determination — harvesting" },
    { name: "Shula", type: "bad", desc: "Thorn — avoid cutting" },
    { name: "Ganda", type: "bad", desc: "Knot — risky operations" },
    { name: "Vriddhi", type: "good", desc: "Growth — excellent for SO ★★★" },
    { name: "Dhruva", type: "good", desc: "Fixed — permanent plantings" },
    { name: "Vyaghata", type: "bad", desc: "Tiger — dangerous, stop ops" },
    { name: "Harshana", type: "good", desc: "Joy — moderate for all" },
    { name: "Vajra", type: "bad", desc: "Thunderbolt — avoid cutting" },
    { name: "Siddhi", type: "great", desc: "Achievement — PERFECT for all ★★★" },
    { name: "Vyatipata", type: "bad", desc: "Calamity — emergency stop advised" },
    { name: "Variyan", type: "good", desc: "Superior — good for spray" },
    { name: "Parigha", type: "bad", desc: "Iron rod — avoid sowing" },
    { name: "Shiva", type: "good", desc: "Auspicious — planting trees" },
    { name: "Siddha", type: "great", desc: "Perfect — all operations ★★★" },
    { name: "Sadhya", type: "good", desc: "Achievable — moderate ops" },
    { name: "Shubha", type: "good", desc: "Auspicious — sowing & spray" },
    { name: "Shukla", type: "good", desc: "Pure — all ops favorable" },
    { name: "Brahma", type: "great", desc: "Creator energy — new plantings ★★★" },
    { name: "Indra", type: "great", desc: "King yoga — best missions ★★★" },
    { name: "Vaidhriti", type: "bad", desc: "Sorrowful — avoid all ops" },
];

const KARANA_NAMES = ["Bava", "Balava", "Kaulava", "Taitila", "Gara", "Vanija", "Vishti", "Shakuni", "Chatushpada", "Naga", "Kimstughna"];

function computePanchang(date) {
    const jd = Math.floor(date.getTime() / 86400000) + 2440588;
    // Sun position (simplified)
    const sunLong = ((jd - 2451545) * 0.9856473 + 280.46) % 360;
    // Moon position (simplified — 13.176° per day)
    const moonLong = ((jd - 2451545) * 13.176396 + 218.316) % 360;
    const moonPhase = ((moonLong - sunLong) % 360 + 360) % 360;

    const tithiNum = Math.floor(moonPhase / 12); // 0-29
    const paksha = tithiNum < 15 ? "Shukla Paksha (Waxing Moon)" : "Krishna Paksha (Waning Moon)";
    const tithiName = TITHIS[tithiNum % 15];
    const nakIdx = Math.floor((moonLong / 360) * 27) % 27;
    const nakshatra = NAKSHATRAS[nakIdx];
    const yogaNum = Math.floor(((sunLong + moonLong) / 360 * 27)) % 27;
    const yoga = YOGAS[yogaNum];
    const karanaNum = Math.floor(moonPhase / 6) % 11;
    const karana = KARANA_NAMES[karanaNum];
    const vara = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][date.getDay()];
    const varaLord = ["Sun", "Moon", "Mars", "Mercury", "Jupiter", "Venus", "Saturn"][date.getDay()];

    // Moon rise/set (simplified)
    const moonRise = new Date(date); moonRise.setHours(6 + Math.floor(tithiNum / 2), 0);
    const moonSet = new Date(date); moonSet.setHours(18 + Math.floor(tithiNum / 2), 30);

    // Farm recommendations
    const soScore = nakIdx === 3 || nakIdx === 7 || nakIdx === 12 || nakIdx === 26 ? 95 : nakIdx === 5 || nakIdx === 8 || nakIdx === 17 ? 10 : nakIdx === 22 || nakIdx === 24 ? 40 : 70;
    const spScore = nakIdx === 4 || nakIdx === 14 || nakIdx === 23 ? 90 : nakIdx === 8 ? 15 : 75;
    const gcScore = tithiNum >= 15 ? 85 : tithiNum === 14 || tithiNum === 0 ? 50 : 70;
    const yogaBoost = yoga.type === "great" ? 15 : yoga.type === "good" ? 5 : yoga.type === "bad" ? -25 : 0;

    // Auspicious windows today
    const windows = [];
    if (soScore + yogaBoost > 70) windows.push({ op: "SO", label: "Sowing", color: T.gr, from: "06:00", to: "10:30", score: soScore + yogaBoost });
    if (spScore + yogaBoost > 70) windows.push({ op: "SP", label: "Spraying", color: T.cy, from: "07:30", to: "11:00", score: spScore + yogaBoost });
    if (gcScore + yogaBoost > 70) windows.push({ op: "GC", label: "Grass Cutting", color: T.ye, from: "08:00", to: "16:00", score: gcScore + yogaBoost });

    return {
        tithiNum, tithiName, paksha, nakshatra, nakIdx, yoga, karana, vara, varaLord,
        moonPhase, moonLong, sunLong, moonRise, moonSet,
        soScore: clamp(soScore + yogaBoost, 0, 100),
        spScore: clamp(spScore + yogaBoost, 0, 100),
        gcScore: clamp(gcScore + yogaBoost, 0, 100),
        windows,
    };
}

function generateWeekCalendar(baseDate) {
    return Array.from({ length: 7 }, (_, i) => {
        const d = new Date(baseDate); d.setDate(d.getDate() - 3 + i);
        return { date: d, panchang: computePanchang(d) };
    });
}

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// UTILITIES
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
const rnd = (a, b) => Math.random() * (b - a) + a;
const rndI = (a, b) => Math.floor(rnd(a, b));
const pf = (n, d = 1) => parseFloat(n.toFixed(d));
const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
const ts = () => new Date().toTimeString().slice(0, 8);
const fmtFID = (id) => `R${String(id).padStart(3, "0")}`;
const pct = (v, t) => t === 0 ? 0 : Math.round((v / t) * 100);

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// COVERAGE GRID — 20×20 cells per zone
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
function initCoverage() {
    const zones = { A: {}, B: {}, C: {}, D: {} };
    for (const z of "ABCD") {
        for (let r = 0; r < 20; r++) for (let c = 0; c < 20; c++) {
            zones[z][`${r},${c}`] = { GC: 0, SP: 0, SO: 0, NDVI: pf(rnd(0.3, 0.9)), SM: rndI(20, 80), crop: rndI(40, 100) };
        }
    }
    return zones;
}

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// ROBOT FACTORY
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
const OP_POOL = "GC,GC,GC,SO,SO,SO,SO,SP,SP,SP,IDLE,IDLE,ERR,RTB".split(",");

function makeRobots() {
    return Array.from({ length: 100 }, (_, i) => {
        const zone = "ABCD"[Math.floor(i / 25)];
        const op = OP_POOL[rndI(0, OP_POOL.length)];
        return {
            id: i + 1, FID: fmtFID(i + 1), op, zone,
            CMD: op === "IDLE" || op === "ERR" ? "S" : "F",
            TURN: ["L", "R", "N"][rndI(0, 3)],
            Speed: op === "IDLE" || op === "ERR" ? 0 : rndI(4, 18),
            GC: op === "GC" ? 1 : 0, SP: op === "SP" ? 1 : 0, SO: op === "SO" ? 1 : 0,
            CB: rndI(25, 100), MB: rndI(20, 100),
            // ── NEW fields ──
            GPS_OK: Math.random() > 0.05 ? 1 : 0,
            CAM_OK: Math.random() > 0.08 ? 1 : 0,
            MOT_L: Math.random() > 0.04 ? 1 : 0,
            MOT_R: Math.random() > 0.04 ? 1 : 0,
            BLADE_OK: Math.random() > 0.06 ? 1 : 0,
            PUMP_OK: Math.random() > 0.07 ? 1 : 0,
            SEED_OK: Math.random() > 0.05 ? 1 : 0,
            SOIL_SENS: Math.random() > 0.06 ? 1 : 0,
            lat: 18.5204 + rnd(-0.02, 0.02),
            lng: 73.8567 + rnd(-0.02, 0.02),
            gpsAcc: pf(rnd(0.5, 3.5)),
            gpsSats: rndI(6, 14),
            NDVI: pf(rnd(0.3, 0.9)),
            SM: rndI(20, 80),
            soilPH: pf(rnd(5.6, 8.2)),
            soilHealth: rndI(45, 100),
            cropHealth: rndI(40, 100),
            camFrame: null,
            sig: rndI(2, 5),
            upd: Date.now() - rndI(0, 12000),
            cbHist: Array.from({ length: 16 }, () => rndI(60, 100)),
            spdHist: Array.from({ length: 16 }, () => rndI(0, 18)),
            covArea: rndI(0, 8000),      // m² covered
            faults: rndI(0, 2),
            organicRisk: Math.random() < 0.04,
            x: (i % 10) * 9.6 + rnd(1.8, 3.4),
            y: Math.floor(i / 10) * 9.6 + rnd(1.8, 3.4),
        };
    });
}

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// HEALTH SCORE
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
function robotHealth(r) {
    const pw = Math.round(r.CB * 0.4 + r.MB * 0.6);
    const cn = [0, 25, 50, 75, 100][clamp(r.sig, 0, 4)];
    const hw = ((r.MOT_L + r.MOT_R + r.BLADE_OK + r.PUMP_OK + r.SEED_OK) / 5) * 100;
    const gps = r.GPS_OK ? 100 : 20;
    return Math.round(pw * 0.30 + cn * 0.20 + hw * 0.30 + gps * 0.20);
}

function predictBat(r) {
    const rate = r.op === "IDLE" ? 0.02 : 0.10;
    return { mins: Math.min(r.CB > 15 ? Math.round((r.CB - 15) / rate) : 0, r.MB > 15 ? Math.round((r.MB - 15) / rate) : 0), rate };
}

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// ALERT DATA
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
const INIT_ALERTS = [
    { id: 1, lvl: "critical", msg: "R042 — MB critical (8%)", t: "12:41:03", rid: 42, ack: false },
    { id: 2, lvl: "warning", msg: "R017 — Soil pH 4.1 anomaly", t: "12:40:51", rid: 17, ack: false },
    { id: 3, lvl: "critical", msg: "R085 — GC blade fault", t: "12:40:22", rid: 85, ack: false },
    { id: 4, lvl: "critical", msg: "R003 — Organic boundary breach", t: "12:39:58", rid: 3, ack: false },
    { id: 5, lvl: "warning", msg: "R061 — Signal weak 1/4", t: "12:39:12", rid: 61, ack: false },
    { id: 6, lvl: "critical", msg: "R019 — Battery critical ~9min", t: "12:37:20", rid: 19, ack: false },
    { id: 7, lvl: "info", msg: "Panchang: Rohini — Best SO day", t: "06:00:00", rid: null, ack: false },
    { id: 8, lvl: "info", msg: "Zone-B SP coverage 98.4%", t: "12:39:45", rid: 33, ack: true },
];

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// MICRO COMPONENTS
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
function BatBar({ pct: p, color, label, warn }) {
    const c = p < 15 ? T.rd : p < 30 ? T.am : color;
    return (
        <div style={{ marginBottom: 8 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3, fontSize: 10 }}>
                <span style={{ color: T.txD }}>{label}</span>
                <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                    {warn && <span style={{ color: T.am, fontSize: 8, animation: "blink 1s infinite" }}>~{warn}m</span>}
                    <span style={{ color: c, fontWeight: 700 }}>{Math.round(p)}%</span>
                </div>
            </div>
            <div style={{ height: 5, background: T.bg4, borderRadius: 3, overflow: "hidden" }}>
                <div style={{
                    width: `${Math.max(0, p)}%`, height: "100%", background: c, borderRadius: 3,
                    transition: "width 1.1s", boxShadow: `0 0 8px ${c}55`
                }} />
            </div>
        </div>
    );
}

function Ring({ score, size = 52, label = "HLTH" }) {
    const c = score >= 75 ? T.gr : score >= 50 ? T.am : T.rd;
    const r = (size / 2) - 5, circ = 2 * Math.PI * r, dash = (score / 100) * circ;
    return (
        <div style={{ position: "relative", width: size, height: size, flexShrink: 0 }}>
            <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
                <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={T.bg4} strokeWidth="4" />
                <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={c} strokeWidth="4"
                    strokeDasharray={`${dash} ${circ}`} strokeLinecap="round"
                    style={{ transition: "stroke-dasharray 1.4s", filter: `drop-shadow(0 0 4px ${c})` }} />
            </svg>
            <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <span style={{ color: c, fontSize: size > 48 ? 13 : 10, fontWeight: 700, lineHeight: 1 }}>{score}</span>
                <span style={{ color: T.txD, fontSize: 7, lineHeight: 1, marginTop: 1 }}>{label}</span>
            </div>
        </div>
    );
}

function Spark({ data, color, w = 72, h = 22 }) {
    if (!data || data.length < 2) return null;
    const max = Math.max(...data), min = Math.min(...data), range = max - min || 1;
    const pts = data.map((v, i) => `${(i / (data.length - 1)) * w},${h - ((v - min) / range) * (h - 4) - 2}`).join(" ");
    return (
        <svg width={w} height={h} style={{ overflow: "visible" }}>
            <polyline points={pts} fill="none" stroke={color} strokeWidth="1.5"
                strokeLinecap="round" strokeLinejoin="round"
                style={{ filter: `drop-shadow(0 0 3px ${color}70)` }} />
        </svg>
    );
}

function SigBars({ sig }) {
    return (
        <div style={{ display: "flex", gap: 2, alignItems: "flex-end" }}>
            {[1, 2, 3, 4].map(i => (
                <div key={i} style={{
                    width: 3, height: i * 3 + 3,
                    background: i <= sig ? (i === 1 ? T.rd : i === 2 ? T.am : T.a) : T.bg4, borderRadius: 1
                }} />
            ))}
        </div>
    );
}

function Pill({ label, val, color, blink }) {
    return (
        <div style={{
            background: T.bg3, borderRadius: 4, padding: "4px 8px", textAlign: "center",
            border: `1px solid ${color}22`, minWidth: 38, flexShrink: 0
        }}>
            <div style={{
                color, fontSize: 14, fontWeight: 700, lineHeight: 1,
                animation: blink ? "blink 1s infinite" : undefined
            }}>{val}</div>
            <div style={{ color: T.txD, fontSize: 7, marginTop: 1, textTransform: "uppercase", letterSpacing: "0.05em" }}>{label}</div>
        </div>
    );
}

function SecH({ label, extra }) {
    return (
        <div style={{
            display: "flex", justifyContent: "space-between", alignItems: "center",
            borderBottom: `1px solid ${T.bg4}`, paddingBottom: 4, marginBottom: 7, marginTop: 4
        }}>
            <span style={{ color: T.txD, fontSize: 8.5, letterSpacing: "0.14em", textTransform: "uppercase" }}>{label}</span>
            {extra && <span style={{ color: T.txD, fontSize: 8 }}>{extra}</span>}
        </div>
    );
}

function DRow({ label, val, color, sub }) {
    return (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 0", borderBottom: `1px solid ${T.bg4}` }}>
            <span style={{ color: T.txD, fontSize: 10 }}>{label}</span>
            <div style={{ textAlign: "right" }}>
                <span style={{ color: color || T.tx, fontSize: 11, fontWeight: 600 }}>{val}</span>
                {sub && <div style={{ color: T.txD, fontSize: 8, marginTop: 1 }}>{sub}</div>}
            </div>
        </div>
    );
}

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// STATUS LED
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
function LED({ ok, label, size = 7 }) {
    const c = ok ? T.gr : T.rd;
    return (
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <div style={{
                width: size, height: size, borderRadius: "50%", background: c,
                boxShadow: `0 0 ${ok ? 6 : 4}px ${c}${ok ? "90" : "70"}`, flexShrink: 0
            }} />
            <span style={{ color: ok ? T.txL : T.rd, fontSize: 9.5 }}>{label}</span>
        </div>
    );
}

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// COVERAGE BAR
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
function CovBar({ label, pct: p, color, total, done }) {
    return (
        <div style={{ marginBottom: 8 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                    <div style={{ width: 7, height: 7, borderRadius: "50%", background: color }} />
                    <span style={{ color: T.txL, fontSize: 10 }}>{label}</span>
                </div>
                <div style={{ textAlign: "right" }}>
                    <span style={{ color: color, fontSize: 12, fontWeight: 700 }}>{p}%</span>
                    <span style={{ color: T.txD, fontSize: 8, marginLeft: 5 }}>{done}/{total}</span>
                </div>
            </div>
            <div style={{ height: 5, background: T.bg4, borderRadius: 3, overflow: "hidden" }}>
                <div style={{
                    width: `${p}%`, height: "100%", background: color, borderRadius: 3,
                    transition: "width 1.2s", boxShadow: `0 0 8px ${color}50`
                }} />
            </div>
        </div>
    );
}

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// PANCHANG SCORE RING (small)
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
function PanchScore({ score, label, color }) {
    const c = score > 75 ? T.gr : score > 50 ? T.am : T.rd;
    const r = 14, circ = 2 * Math.PI * r, dash = (score / 100) * circ;
    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
            <div style={{ position: "relative", width: 36, height: 36 }}>
                <svg width="36" height="36" style={{ transform: "rotate(-90deg)" }}>
                    <circle cx="18" cy="18" r={r} fill="none" stroke={T.bg4} strokeWidth="3.5" />
                    <circle cx="18" cy="18" r={r} fill="none" stroke={color || c} strokeWidth="3.5"
                        strokeDasharray={`${dash} ${circ}`} strokeLinecap="round"
                        style={{ filter: `drop-shadow(0 0 3px ${color || c})` }} />
                </svg>
                <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <span style={{ color: color || c, fontSize: 9, fontWeight: 700 }}>{score}</span>
                </div>
            </div>
            <span style={{ color: T.txD, fontSize: 8, textAlign: "center" }}>{label}</span>
        </div>
    );
}

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// MOON PHASE SVG
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
function MoonSVG({ phase, size = 40 }) {
    const r = size / 2 - 2;
    const lit = phase / 360;
    const path = lit <= 0.5
        ? `M ${size / 2} ${2} A ${r} ${r} 0 1 1 ${size / 2} ${size - 2} A ${r * (1 - lit * 2)} ${r} 0 1 0 ${size / 2} ${2}`
        : `M ${size / 2} ${2} A ${r} ${r} 0 1 0 ${size / 2} ${size - 2} A ${r * ((lit - 0.5) * 2)} ${r} 0 1 1 ${size / 2} ${2}`;
    return (
        <svg width={size} height={size}>
            <circle cx={size / 2} cy={size / 2} r={r} fill={T.bg3} stroke={T.txX} strokeWidth="1" />
            <path d={path} fill="#c8dde8" opacity="0.85" />
        </svg>
    );
}

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// MAIN MAP SVG
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
function FarmMap({ robots, coverage, sel, msel, focus, batch, flash, mapLayer, onClick, zoneCov }) {
    const opColors = { GC: T.ye, SP: T.cy, SO: T.gr };
    return (
        <svg viewBox="0 0 100 100" style={{ width: "100%", height: "100%", display: "block" }}
            xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient id="fg" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#010e07" /><stop offset="100%" stopColor="#010b08" />
                </linearGradient>
                <pattern id="cr" x="0" y="0" width="5" height="1.8" patternUnits="userSpaceOnUse">
                    <line x1="0" y1="0.9" x2="5" y2="0.9" stroke="rgba(0,80,20,0.28)" strokeWidth="0.38" />
                </pattern>
                <radialGradient id="sg" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor="#00e5a0" stopOpacity="0.22" />
                    <stop offset="100%" stopColor="#00e5a0" stopOpacity="0" />
                </radialGradient>
            </defs>

            <rect width="100" height="100" fill="url(#fg)" />
            <rect width="100" height="100" fill="url(#cr)" />

            {/* Zone fills */}
            {[["A", 0, 0], ["B", 50, 0], ["C", 0, 50], ["D", 50, 50]].map(([z, ox, oy]) => (
                <rect key={z} x={ox} y={oy} width="50" height="50"
                    fill={z === "A" ? "rgba(0,100,30,0.07)" : z === "B" ? "rgba(0,80,80,0.07)" : z === "C" ? "rgba(80,100,0,0.07)" : "rgba(0,50,100,0.07)"} />
            ))}

            {/* Coverage overlay — only active robots' coverage trails */}
            {mapLayer === "coverage" && robots.map(r => {
                if (!r.GC && !r.SP && !r.SO) return null;
                const color = r.GC ? T.ye : r.SP ? T.cy : T.gr;
                return (
                    <circle key={`cov${r.id}`} cx={r.x} cy={r.y} r={3.5}
                        fill={color} opacity={0.12} />
                );
            })}

            {/* NDVI / Crop health overlay */}
            {mapLayer === "crop" && robots.map(r => {
                const c = r.NDVI > 0.7 ? "#00e676" : r.NDVI > 0.5 ? "#ffd740" : "#ff2d55";
                return <circle key={`ndvi${r.id}`} cx={r.x} cy={r.y} r={4} fill={c} opacity={0.18} />;
            })}

            {/* Soil moisture overlay */}
            {mapLayer === "soil" && robots.map(r => {
                const op = r.SM / 100 * 0.35;
                return <circle key={`sm${r.id}`} cx={r.x} cy={r.y} r={4} fill={T.cy} opacity={op} />;
            })}

            {/* Farm roads */}
            <line x1="50" y1="0" x2="50" y2="100" stroke="rgba(180,150,80,0.20)" strokeWidth="1.4" />
            <line x1="0" y1="50" x2="100" y2="50" stroke="rgba(180,150,80,0.20)" strokeWidth="1.4" />
            <rect x="48.3" y="48.3" width="3.4" height="3.4" rx="0.5" fill="rgba(200,170,100,0.22)" />

            {/* Irrigation lines */}
            {[25, 75].map(x => <line key={`il${x}`} x1={x} y1="0" x2={x} y2="100" stroke="rgba(0,180,255,0.10)" strokeWidth="0.4" strokeDasharray="1,3" />)}
            {[25, 75].map(y => <line key={`ih${y}`} x1="0" y1={y} x2="100" y2={y} stroke="rgba(0,180,255,0.10)" strokeWidth="0.4" strokeDasharray="1,3" />)}

            {/* Zone dividers */}
            <line x1="50" y1="0" x2="50" y2="100" stroke="rgba(0,229,160,0.18)" strokeWidth="0.55" strokeDasharray="3,2" />
            <line x1="0" y1="50" x2="100" y2="50" stroke="rgba(0,229,160,0.18)" strokeWidth="0.55" strokeDasharray="3,2" />

            {/* Farm boundary */}
            <rect x="0.5" y="0.5" width="99" height="99" fill="none" stroke="rgba(0,229,160,0.22)" strokeWidth="0.55" />

            {/* Organic boundary Zone-A */}
            <rect x="1.5" y="1.5" width="47" height="47" fill="none"
                stroke={T.pu} strokeWidth="0.32" strokeDasharray="1.5,1" opacity="0.38" />
            <text x="3" y="5" style={{ fill: T.pu, fontSize: "1.7px", fontFamily: "monospace", opacity: 0.55 }}>ORGANIC ZONE-A</text>

            {/* Base stations */}
            {[[2, 2], [96, 2], [2, 96], [96, 96]].map(([bx, by], i) => (
                <g key={i}>
                    <rect x={bx - 2} y={by - 2} width="4" height="4" rx="0.4"
                        fill="rgba(0,229,160,0.13)" stroke="rgba(0,229,160,0.45)" strokeWidth="0.4" />
                    <text x={bx} y={by + 0.6} textAnchor="middle" dominantBaseline="middle"
                        style={{ fill: "rgba(0,229,160,0.65)", fontSize: "1.3px", fontFamily: "monospace" }}>BASE</text>
                </g>
            ))}

            {/* Zone watermarks */}
            {[["A", 25, 25], ["B", 75, 25], ["C", 25, 75], ["D", 75, 75]].map(([z, x, y]) => (
                <text key={z} x={x} y={y} textAnchor="middle" dominantBaseline="middle"
                    style={{ fill: "rgba(0,229,160,0.04)", fontSize: "16px", fontWeight: "bold", fontFamily: "monospace" }}>{z}</text>
            ))}

            {/* Zone coverage % badges */}
            {Object.entries(zoneCov).map(([z, cv]) => {
                const [lx, ly] = { A: [1, 48], B: [51, 48], C: [1, 98], D: [51, 98] }[z];
                const tot = cv.GC + cv.SP + cv.SO;
                return (
                    <g key={z}>
                        <rect x={lx} y={ly - 4.5} width={19} height={5.5} rx="0.8"
                            fill="rgba(5,21,37,0.85)" stroke="rgba(0,229,160,0.25)" strokeWidth="0.3" />
                        <text x={lx + 1} y={ly - 0.8} style={{ fill: T.txD, fontSize: "1.7px", fontFamily: "monospace" }}>
                            Z{z} SO:{cv.SO}% SP:{cv.SP}% GC:{cv.GC}%
                        </text>
                    </g>
                );
            })}

            {/* ── ROBOTS ── */}
            {robots.map(r => {
                const opK = r.GC ? "GC" : r.SP ? "SP" : r.SO ? "SO" : r.op === "ERR" ? "ERR" : r.op === "RTB" ? "RTB" : "IDLE";
                const colors = { GC: T.ye, SP: T.cy, SO: T.gr, ERR: T.rd, RTB: T.or, IDLE: T.txX };
                const dotR = { GC: 3.1, SP: 3.1, SO: 3.1, ERR: 3.5, RTB: 2.8, IDLE: 2.2 };
                const dotC = colors[opK];
                const dotS = dotR[opK];
                const isSel = r.id === sel, isM = msel.has(r.id), isErr = opK === "ERR";
                const fade = focus && !batch ? (isSel ? 1 : 0.07) : 1;
                const hasFault = !r.MOT_L || !r.MOT_R || !r.GPS_OK || !r.CAM_OK || !r.BLADE_OK || !r.PUMP_OK || !r.SEED_OK;
                const lowB = r.CB < 20 || r.MB < 20;

                return (
                    <g key={r.id} onClick={() => onClick(r)} style={{ cursor: "pointer" }}>
                        {isSel && <circle cx={r.x} cy={r.y} r={9} fill="url(#sg)" opacity={0.7} />}
                        {r.organicRisk && <circle cx={r.x} cy={r.y} r={6.5} fill="none" stroke={T.pu}
                            strokeWidth="0.28" strokeDasharray="1,0.8" opacity={0.45} />}
                        {isM && <circle cx={r.x} cy={r.y} r={5.5} fill={`${T.cy}15`} stroke={T.cy} strokeWidth="0.6" opacity={0.9} />}
                        {isSel && !isM && <>
                            <circle cx={r.x} cy={r.y} r={5.8} fill="none" stroke={T.a} strokeWidth="0.7" opacity={0.95} />
                            <circle cx={r.x} cy={r.y} r={7.5} fill="none" stroke={T.a} strokeWidth="0.22" opacity={0.28} />
                        </>}
                        {isErr && <circle cx={r.x} cy={r.y} r={5} fill="none" stroke={T.rd}
                            strokeWidth="0.35" opacity={flash ? 0.85 : 0.1} />}
                        {/* GPS fault ring */}
                        {!r.GPS_OK && <circle cx={r.x} cy={r.y} r={4.8} fill="none" stroke={T.or}
                            strokeWidth="0.3" strokeDasharray="0.8,0.6" opacity={0.7} />}
                        {/* Body */}
                        <circle cx={r.x} cy={r.y} r={dotS} fill={isErr && flash ? "#fff" : dotC}
                            opacity={fade} style={{ filter: `drop-shadow(0 0 2px ${dotC}80)` }} />
                        {/* Low battery indicator */}
                        {lowB && <circle cx={r.x + 2.7} cy={r.y - 2.7} r={1.1} fill={T.am} opacity={fade} />}
                        {/* Hardware fault indicator */}
                        {hasFault && !isErr && <circle cx={r.x - 2.6} cy={r.y - 2.6} r={1} fill={T.rd} opacity={fade} />}
                        {/* Camera fault */}
                        {!r.CAM_OK && <text x={r.x + 2.3} y={r.y + 3.5} style={{ fill: T.rd, fontSize: "2.2px", fontFamily: "monospace", opacity: fade }}>📷</text>}
                    </g>
                );
            })}

            {/* Selected robot callout */}
            {sel && (() => {
                const r = robots.find(x => x.id === sel); if (!r) return null;
                const left = r.x > 65, bx = left ? r.x - 27 : r.x + 3, by = r.y - 16;
                const opK = r.GC ? "GC" : r.SP ? "SP" : r.SO ? "SO" : r.op;
                const opC = { GC: T.ye, SP: T.cy, SO: T.gr, ERR: T.rd, RTB: T.or, IDLE: T.txD }[opK] || T.txD;
                return (
                    <g>
                        <line x1={r.x} y1={r.y} x2={left ? r.x - 5 : r.x + 5} y2={r.y - 8}
                            stroke={T.a} strokeWidth="0.28" opacity={0.5} />
                        <rect x={bx} y={by} width={24} height={16} rx="1.2"
                            fill={T.bg1} stroke={T.a} strokeWidth="0.4" opacity={0.97} />
                        <text x={bx + 1.5} y={by + 4} style={{ fill: T.a, fontSize: "2.8px", fontFamily: "monospace", fontWeight: "bold" }}>{r.FID}</text>
                        <text x={bx + 1.5} y={by + 7} style={{ fill: opC, fontSize: "1.9px", fontFamily: "monospace" }}>{opK}</text>
                        <text x={bx + 1.5} y={by + 10} style={{ fill: T.txD, fontSize: "1.8px", fontFamily: "monospace" }}>CB:{Math.round(r.CB)}% MB:{Math.round(r.MB)}%</text>
                        <text x={bx + 1.5} y={by + 13} style={{ fill: T.txD, fontSize: "1.8px", fontFamily: "monospace" }}>NDVI:{r.NDVI.toFixed(2)} SM:{r.SM}%</text>
                    </g>
                );
            })()}

            {/* Compass */}
            <g transform="translate(95.5,94.5)">
                <circle r="4" fill={T.bg2} stroke="rgba(0,229,160,0.22)" strokeWidth="0.5" />
                <text textAnchor="middle" y="-1.2" style={{ fill: T.a, fontSize: "2px", fontFamily: "monospace", fontWeight: "bold" }}>N</text>
                <text textAnchor="middle" y="3.2" style={{ fill: T.txD, fontSize: "1.6px", fontFamily: "monospace" }}>S</text>
                <text x="-2.5" y="0.8" textAnchor="middle" style={{ fill: T.txD, fontSize: "1.6px", fontFamily: "monospace" }}>W</text>
                <text x="2.5" y="0.8" textAnchor="middle" style={{ fill: T.txD, fontSize: "1.6px", fontFamily: "monospace" }}>E</text>
            </g>
            <line x1="3" y1="97.5" x2="23" y2="97.5" stroke={T.txD} strokeWidth="0.32" />
            {[3, 23].map(x => <line key={x} x1={x} y1="96.5" x2={x} y2="98.5" stroke={T.txD} strokeWidth="0.32" />)}
            <text x="13" y="96" textAnchor="middle" style={{ fill: T.txD, fontSize: "1.7px", fontFamily: "monospace" }}>500m</text>
            <circle cx="97" cy="3.5" r="1.2" fill={T.a} stroke={T.a} strokeWidth="0.4"
                style={{ filter: `drop-shadow(0 0 4px ${T.a})` }} />
            <text x="94" y="4" textAnchor="end" style={{ fill: T.a, fontSize: "1.7px", fontFamily: "monospace", letterSpacing: "0.1em" }}>LIVE</text>
        </svg>
    );
}

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// MAIN COMMAND CENTER
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
export function AgriCommandCenterV2() {
    const [robots, setRobots] = useState(makeRobots);
    const [coverage] = useState(initCoverage);
    const [alerts, setAlerts] = useState(INIT_ALERTS);
    const [sel, setSel] = useState(null);
    const [msel, setMsel] = useState(new Set());
    const [estop, setEstop] = useState(false);
    const [focus, setFocus] = useState(false);
    const [batch, setBatch] = useState(false);
    const [tick, setTick] = useState(0);
    const [now, setNow] = useState(new Date());
    const [weather, setWeather] = useState({ wind: 11.4, rain: 0, temp: 24.1, hum: 60 });
    const [mapLayer, setMapLayer] = useState("normal");
    // Panel tabs
    const [ltab, setLtab] = useState("alerts");
    const [rtab, setRtab] = useState("telemetry");
    const [mainTab, setMainTab] = useState("map"); // map | coverage | panchang
    const [cmdSent, setCmdSent] = useState(false);
    const estopRef = useRef(false); estopRef.current = estop;

    // Panchang
    const panchang = useMemo(() => computePanchang(now), [now.toDateString()]);
    const weekCal = useMemo(() => generateWeekCalendar(now), [now.toDateString()]);

    // Live simulation
    useEffect(() => {
        const iv = setInterval(() => {
            setNow(new Date()); setTick(t => t + 1);
            if (!estopRef.current) {
                setRobots(p => p.map(r => ({
                    ...r,
                    CB: clamp(r.CB - rnd(0, 0.06), 0, 100),
                    MB: clamp(r.MB - rnd(0, 0.10), 0, 100),
                    Speed: r.CMD === "S" || r.op === "IDLE" ? 0 : clamp(r.Speed + rnd(-0.4, 0.4), 0, 20),
                    soilPH: pf(clamp(r.soilPH + rnd(-0.02, 0.02), 4, 9)),
                    NDVI: pf(clamp(r.NDVI + rnd(-0.005, 0.005), 0.1, 1)),
                    SM: clamp(r.SM + rndI(-1, 1), 5, 95),
                    upd: Math.random() > 0.05 ? Date.now() : r.upd,
                    cbHist: [...r.cbHist.slice(1), Math.round(r.CB)],
                    spdHist: [...r.spdHist.slice(1), Math.round(r.Speed)],
                    covArea: r.op !== "IDLE" && r.op !== "ERR" ? r.covArea + rndI(0, 3) : r.covArea,
                })));
                setWeather(p => ({ ...p, wind: pf(clamp(p.wind + rnd(-0.3, 0.3), 0, 40)), temp: pf(clamp(p.temp + rnd(-0.08, 0.08), 10, 42)) }));
            }
        }, 1000);
        return () => clearInterval(iv);
    }, []);

    const robot = robots.find(r => r.id === sel);
    const flash = tick % 2 === 0;

    // Zone coverage aggregates
    const zoneCov = useMemo(() => {
        const z = { A: { GC: 0, SP: 0, SO: 0 }, B: { GC: 0, SP: 0, SO: 0 }, C: { GC: 0, SP: 0, SO: 0 }, D: { GC: 0, SP: 0, SO: 0 } };
        const cnt = { A: { GC: 0, SP: 0, SO: 0, tot: 25 }, B: { GC: 0, SP: 0, SO: 0, tot: 25 }, C: { GC: 0, SP: 0, SO: 0, tot: 25 }, D: { GC: 0, SP: 0, SO: 0, tot: 25 } };
        robots.forEach(r => { if (r.GC) cnt[r.zone].GC++; if (r.SP) cnt[r.zone].SP++; if (r.SO) cnt[r.zone].SO++; });
        "ABCD".split("").forEach(zone => {
            z[zone].GC = pct(cnt[zone].GC, cnt[zone].tot);
            z[zone].SP = pct(cnt[zone].SP, cnt[zone].tot);
            z[zone].SO = pct(cnt[zone].SO, cnt[zone].tot);
        });
        return z;
    }, [robots]);

    // Fleet stats
    const stats = useMemo(() => ({
        gc: robots.filter(r => r.GC).length,
        sp: robots.filter(r => r.SP).length,
        so: robots.filter(r => r.SO).length,
        err: robots.filter(r => r.op === "ERR").length,
        lowB: robots.filter(r => r.CB < 20 || r.MB < 20).length,
        crit: alerts.filter(a => a.lvl === "critical" && !a.ack).length,
        conn: robots.filter(r => Date.now() - r.upd < 25000).length,
        avgH: Math.round(robots.reduce((s, r) => s + robotHealth(r), 0) / 100),
        totalCov: robots.reduce((s, r) => s + r.covArea, 0),
        gcCov: pct(robots.filter(r => r.GC).length, robots.filter(r => r.zone === "A" || r.zone === "D").length || 1),
        spCov: pct(robots.filter(r => r.SP).length, robots.filter(r => r.zone === "B").length || 1),
        soCov: pct(robots.filter(r => r.SO).length, 100),
        faults: robots.filter(r => !r.MOT_L || !r.MOT_R || !r.GPS_OK || !r.BLADE_OK || !r.PUMP_OK).length,
    }), [robots, alerts]);

    const doEstop = useCallback(() => {
        if (estop) return;
        setEstop(true);
        setAlerts(p => [{ id: Date.now(), lvl: "critical", msg: "🛑 EMERGENCY STOP — All 100 robots halted", t: ts(), rid: null, ack: false }, ...p.slice(0, 28)]);
        setTimeout(() => setEstop(false), 10000);
    }, [estop]);

    const doClick = useCallback((r) => {
        if (batch) { setMsel(p => { const n = new Set(p); n.has(r.id) ? n.delete(r.id) : n.add(r.id); return n; }); }
        else { setSel(p => p === r.id ? null : r.id); setFocus(true); }
    }, [batch]);

    const sendCmd = useCallback((field, val) => {
        if (!sel) return;
        setRobots(p => p.map(r => {
            if (r.id !== sel) return r;
            const u = { ...r, [field]: val };
            if (field === "GC" && val) { u.SP = 0; u.SO = 0; u.op = "GC"; }
            if (field === "SP" && val) { u.GC = 0; u.SO = 0; u.op = "SP"; }
            if (field === "SO" && val) { u.GC = 0; u.SP = 0; u.op = "SO"; }
            if (field === "CMD") u.Speed = val === "S" ? 0 : r.Speed || 8;
            return u;
        }));
        setCmdSent(true); setTimeout(() => setCmdSent(false), 2500);
    }, [sel]);

    const yogaC = panchang.yoga.type === "great" ? T.gr : panchang.yoga.type === "good" ? T.a : T.rd;
    const rh = robot ? robotHealth(robot) : 0;
    const rp = robot ? predictBat(robot) : {};

    return (
        <div style={{
            background: T.bg0, color: T.tx, fontFamily: '"IBM Plex Mono","Fira Mono","Courier New",monospace',
            height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden", fontSize: "12px", userSelect: "none"
        }}>
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500;600;700&display=swap');
        *{box-sizing:border-box}
        ::-webkit-scrollbar{width:3px;height:3px}
        ::-webkit-scrollbar-track{background:${T.bg1}}
        ::-webkit-scrollbar-thumb{background:${T.bg4};border-radius:2px}
        @keyframes blink{0%,100%{opacity:1}50%{opacity:0.18}}
        @keyframes pulse{0%,100%{opacity:1}50%{opacity:0.35}}
        @keyframes fadeIn{from{opacity:0;transform:translateY(-3px)}to{opacity:1;transform:translateY(0)}}
        @keyframes shimmer{0%{opacity:0.6}50%{opacity:1}100%{opacity:0.6}}
      `}</style>

            {/* ╔══ TOP BAR ══╗ */}
            <div style={{
                display: "flex", alignItems: "center", gap: 7, padding: "5px 12px",
                background: T.bg1, borderBottom: `1px solid ${T.br}`, flexShrink: 0, minHeight: 50
            }}>
                <div style={{ flexShrink: 0 }}>
                    <div style={{
                        color: T.a, fontSize: 12, fontWeight: 700, letterSpacing: "0.16em", lineHeight: 1,
                        textShadow: `0 0 18px ${T.a}55`
                    }}>BHUHIT-OPS</div>
                    <div style={{ color: T.txD, fontSize: 6.5, letterSpacing: "0.14em", marginTop: 1 }}>COMMAND CENTER v4.0 — PANCHANG INTELLIGENCE</div>
                </div>
                <div style={{ width: 1, height: 26, background: T.br }} />

                <Pill label="Fleet" val={100} color={T.a} />
                <Pill label="GC" val={stats.gc} color={T.ye} />
                <Pill label="SP" val={stats.sp} color={T.cy} />
                <Pill label="SO" val={stats.so} color={T.gr} />
                <Pill label="Errors" val={stats.err} color={T.rd} blink={stats.err > 0} />
                <Pill label="Faults" val={stats.faults} color={T.or} blink={stats.faults > 2} />
                <Pill label="Low Bat" val={stats.lowB} color={T.am} />
                <Pill label="Alerts" val={stats.crit} color={T.rd} blink={stats.crit > 0} />
                <Pill label="Avg Hlth" val={stats.avgH} color={stats.avgH >= 75 ? T.gr : stats.avgH >= 50 ? T.am : T.rd} />

                <div style={{ flex: 1 }} />

                {/* Panchang quick strip */}
                <div style={{
                    display: "flex", gap: 8, alignItems: "center", padding: "3px 9px",
                    background: T.bg3, borderRadius: 4, border: `1px solid ${T.pu}22`, fontSize: 8.5, flexShrink: 0
                }}>
                    <MoonSVG phase={panchang.moonPhase} size={22} />
                    <div>
                        <div style={{ color: T.pu, fontWeight: 600 }}>{panchang.nakshatra.name}</div>
                        <div style={{ color: T.txD, fontSize: 7.5 }}>{panchang.tithiName} · {panchang.paksha.split(" ")[0] + " " + panchang.paksha.split(" ")[1]}</div>
                    </div>
                    <div style={{ width: 1, height: 18, background: T.br }} />
                    <div>
                        <div style={{ color: yogaC, fontSize: 8.5, fontWeight: 600 }}>{panchang.yoga.name} Yoga</div>
                        <div style={{ color: T.txD, fontSize: 7.5 }}>{panchang.yoga.type === "great" ? "Perfect day ★" : panchang.yoga.type === "good" ? "Favorable" : panchang.yoga.type === "bad" ? "Caution ⚠" : ""}</div>
                    </div>
                    <div style={{ width: 1, height: 18, background: T.br }} />
                    <div style={{ display: "flex", gap: 5 }}>
                        <PanchScore score={panchang.soScore} label="SO" color={T.gr} />
                        <PanchScore score={panchang.spScore} label="SP" color={T.cy} />
                        <PanchScore score={panchang.gcScore} label="GC" color={T.ye} />
                    </div>
                </div>

                <div style={{ width: 1, height: 26, background: T.br }} />

                {/* Weather */}
                <div style={{
                    display: "flex", gap: 8, alignItems: "center", padding: "3px 8px",
                    background: T.bg3, borderRadius: 4, border: `1px solid ${T.br}`, fontSize: 8.5, color: T.txL, flexShrink: 0
                }}>
                    <span style={{ color: weather.wind > 25 ? T.am : T.a }}>{weather.wind > 25 ? "⚠ " : ""}WIND {weather.wind.toFixed(1)}</span>
                    <span>TEMP {weather.temp.toFixed(1)}°C</span>
                    <span>HUM {weather.hum}%</span>
                </div>

                {/* Clock */}
                <div style={{ textAlign: "right", flexShrink: 0 }}>
                    <div style={{ color: T.tx, fontSize: 13, fontWeight: 700 }}>{now.toTimeString().slice(0, 8)}</div>
                    <div style={{ color: T.txD, fontSize: 7, marginTop: 1 }}>{now.toDateString()}</div>
                </div>

                {/* E-STOP */}
                <button onClick={doEstop} style={{
                    background: estop ? T.rd : "rgba(255,45,85,0.10)", border: `2px solid ${T.rd}`,
                    color: estop ? "#fff" : T.rd, borderRadius: 5, padding: "7px 14px", cursor: "pointer",
                    fontSize: 10.5, fontWeight: 700, letterSpacing: "0.12em", flexShrink: 0,
                    boxShadow: estop ? `0 0 28px ${T.rd}80` : undefined,
                    animation: estop ? "blink 0.5s infinite" : undefined, transition: "all 0.2s"
                }}>
                    {estop ? "STOPPED" : "⬛ STOP ALL"}
                </button>
            </div>

            {estop && (
                <div style={{
                    background: "rgba(255,45,85,0.11)", borderBottom: `1px solid ${T.rd}`,
                    padding: "3px 14px", textAlign: "center", color: T.rd, fontSize: 9.5,
                    fontWeight: 700, letterSpacing: "0.18em", animation: "pulse 0.7s infinite", flexShrink: 0
                }}>
                    EMERGENCY STOP ACTIVE — CMD:S → ALL 100 ROBOTS — SAFE SHUTDOWN IN PROGRESS
                </div>
            )}

            {/* ╔══ MAIN ══╗ */}
            <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>

                {/* ═══ LEFT PANEL ═══ */}
                <div style={{
                    width: 265, display: "flex", flexDirection: "column", borderRight: `1px solid ${T.br}`,
                    overflow: "hidden", background: T.bg1, flexShrink: 0
                }}>
                    <div style={{ display: "flex", borderBottom: `1px solid ${T.br}`, flexShrink: 0 }}>
                        {[{ k: "alerts", l: `Alerts (${stats.crit})` }, { k: "coverage", l: "Coverage" }, { k: "sensors", l: "Sensors" }].map(t => (
                            <button key={t.k} onClick={() => setLtab(t.k)} style={{
                                flex: 1, background: ltab === t.k ? T.bg2 : "transparent", border: "none",
                                borderBottom: `2px solid ${ltab === t.k ? T.a : "transparent"}`,
                                color: ltab === t.k ? T.a : T.txD, padding: "6px 0", cursor: "pointer",
                                fontSize: 9, letterSpacing: "0.07em", textTransform: "uppercase", transition: "all 0.15s"
                            }}>
                                {t.l}
                            </button>
                        ))}
                    </div>

                    {/* ALERTS */}
                    {ltab === "alerts" && (
                        <div style={{ display: "flex", flexDirection: "column", overflow: "hidden", flex: 1 }}>
                            <div style={{ padding: "5px 8px", display: "flex", gap: 4, borderBottom: `1px solid ${T.br}`, flexShrink: 0 }}>
                                {["critical", "warning", "info"].map(lv => {
                                    const c = { critical: T.rd, warning: T.am, info: T.cy }[lv];
                                    return <div key={lv} style={{ background: `${c}14`, border: `1px solid ${c}38`, borderRadius: 3, padding: "2px 7px", fontSize: 8, color: c }}>{alerts.filter(a => a.lvl === lv).length} {lv}</div>;
                                })}
                            </div>
                            <div style={{ flex: 1, overflowY: "auto" }}>
                                {alerts.map(a => {
                                    const c = { critical: T.rd, warning: T.am, info: T.cy }[a.lvl] || T.txD;
                                    return (
                                        <div key={a.id} onClick={() => a.rid && setSel(a.rid)}
                                            style={{
                                                display: "flex", gap: 7, padding: "6px 8px", borderBottom: `1px solid ${T.bg3}`,
                                                borderLeft: `3px solid ${c}`, cursor: a.rid ? "pointer" : "default", opacity: a.ack ? 0.38 : 1, transition: "background 0.12s"
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.background = T.bg2}
                                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ color: T.tx, fontSize: 10, lineHeight: 1.5 }}>{a.msg}</div>
                                                <div style={{ color: T.txD, fontSize: 8, marginTop: 1 }}>{a.t}{a.rid ? ` · R${String(a.rid).padStart(3, "0")}` : ""}</div>
                                            </div>
                                            {!a.ack && <button onClick={e => { e.stopPropagation(); setAlerts(p => p.map(x => x.id === a.id ? { ...x, ack: true } : x)); }}
                                                style={{ background: "transparent", border: `1px solid ${T.txX}`, borderRadius: 2, color: T.txD, fontSize: 7, padding: "1px 4px", cursor: "pointer", flexShrink: 0 }}>ACK</button>}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* COVERAGE */}
                    {ltab === "coverage" && (
                        <div style={{ flex: 1, overflowY: "auto", padding: "10px 11px" }}>
                            <SecH label="Fleet Coverage" />
                            <CovBar label="Grass Cutting (GC)" pct={stats.gcCov} color={T.ye} total={100} done={stats.gc} />
                            <CovBar label="Spraying (SP)" pct={stats.spCov} color={T.cy} total={100} done={stats.sp} />
                            <CovBar label="Sowing (SO)" pct={stats.soCov} color={T.gr} total={100} done={stats.so} />

                            <div style={{ marginTop: 12 }}>
                                <SecH label="Zone Coverage Breakdown" />
                                {["A", "B", "C", "D"].map(z => (
                                    <div key={z} style={{ background: T.bg3, borderRadius: 5, padding: "8px 9px", marginBottom: 7, border: `1px solid ${T.br}` }}>
                                        <div style={{ color: T.a, fontSize: 10, fontWeight: 700, marginBottom: 6 }}>ZONE {z}</div>
                                        {[["GC", T.ye], ["SP", T.cy], ["SO", T.gr]].map(([op, c]) => (
                                            <div key={op} style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 4 }}>
                                                <div style={{ width: 6, height: 6, borderRadius: "50%", background: c, flexShrink: 0 }} />
                                                <span style={{ color: T.txD, fontSize: 9.5, minWidth: 20 }}>{op}</span>
                                                <div style={{ flex: 1, height: 4, background: T.bg4, borderRadius: 2, overflow: "hidden" }}>
                                                    <div style={{ width: `${zoneCov[z][op]}%`, height: "100%", background: c, transition: "width 1s", boxShadow: `0 0 5px ${c}50` }} />
                                                </div>
                                                <span style={{ color: c, fontSize: 10, fontWeight: 700, minWidth: 28 }}>{zoneCov[z][op]}%</span>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>

                            <SecH label="Total Area Covered" />
                            <div style={{ background: T.bg3, borderRadius: 5, padding: "10px", border: `1px solid ${T.br}`, textAlign: "center" }}>
                                <div style={{ color: T.a, fontSize: 22, fontWeight: 700 }}>{(stats.totalCov / 10000).toFixed(2)}</div>
                                <div style={{ color: T.txD, fontSize: 9, marginTop: 2 }}>Hectares covered (live)</div>
                                <div style={{ marginTop: 8, display: "flex", justifyContent: "space-around" }}>
                                    {[[stats.gc * 0.8, "GC", T.ye], [stats.sp * 0.6, "SP", T.cy], [stats.so * 0.4, "SO", T.gr]].map(([v, l, c], i) => (
                                        <div key={i} style={{ textAlign: "center" }}>
                                            <div style={{ color: c, fontSize: 13, fontWeight: 700 }}>{v.toFixed(1)}</div>
                                            <div style={{ color: T.txD, fontSize: 8 }}>{l} ha</div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div style={{ marginTop: 12 }}>
                                <SecH label="Plant-Level Coverage" />
                                <div style={{ background: T.bg3, borderRadius: 5, padding: "9px", border: `1px solid ${T.br}` }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                                        <span style={{ color: T.txD, fontSize: 9 }}>Plants Reached</span>
                                        <span style={{ color: T.a, fontSize: 11, fontWeight: 700 }}>{(stats.totalCov / 0.3).toFixed(0)}</span>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                                        <span style={{ color: T.txD, fontSize: 9 }}>Coverage Density</span>
                                        <span style={{ color: T.cy, fontSize: 11, fontWeight: 700 }}>{((stats.gc + stats.sp + stats.so) / 100 * 100).toFixed(1)}%</span>
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <span style={{ color: T.txD, fontSize: 9 }}>Missed Patches</span>
                                        <span style={{ color: T.am, fontSize: 11, fontWeight: 700 }}>{Math.max(0, 100 - (stats.gc + stats.sp + stats.so))} zones</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* SENSORS FLEET STATUS */}
                    {ltab === "sensors" && (
                        <div style={{ flex: 1, overflowY: "auto", padding: "10px 11px" }}>
                            <SecH label="Fleet Hardware Status" />
                            {[
                                ["Left Motor (MOT_L)", robots.filter(r => !r.MOT_L).length, T.gr],
                                ["Right Motor (MOT_R)", robots.filter(r => !r.MOT_R).length, T.gr],
                                ["GPS Lock", robots.filter(r => !r.GPS_OK).length, T.cy],
                                ["Camera (CAM)", robots.filter(r => !r.CAM_OK).length, T.cy],
                                ["GC Blade", robots.filter(r => !r.BLADE_OK).length, T.ye],
                                ["SP Pump", robots.filter(r => !r.PUMP_OK).length, T.cy],
                                ["SO Mechanism", robots.filter(r => !r.SEED_OK).length, T.gr],
                                ["Soil Sensor", robots.filter(r => !r.SOIL_SENS).length, T.a],
                            ].map(([label, faults, color]) => (
                                <div key={label} style={{
                                    display: "flex", alignItems: "center", justifyContent: "space-between",
                                    padding: "5px 7px", marginBottom: 3, background: T.bg3, borderRadius: 4,
                                    border: `1px solid ${faults > 0 ? T.rd + "30" : T.br}`
                                }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
                                        <div style={{
                                            width: 7, height: 7, borderRadius: "50%",
                                            background: faults === 0 ? T.gr : faults < 3 ? T.am : T.rd,
                                            boxShadow: `0 0 6px ${faults === 0 ? T.gr : faults < 3 ? T.am : T.rd}80`
                                        }} />
                                        <span style={{ color: T.txL, fontSize: 9.5 }}>{label}</span>
                                    </div>
                                    <div style={{ textAlign: "right" }}>
                                        <span style={{ color: faults === 0 ? T.a : T.rd, fontSize: 10, fontWeight: 700 }}>
                                            {100 - faults}/100
                                        </span>
                                        {faults > 0 && <div style={{ color: T.rd, fontSize: 7.5 }}>{faults} fault{faults > 1 ? "s" : ""}</div>}
                                    </div>
                                </div>
                            ))}

                            <div style={{ marginTop: 12 }}>
                                <SecH label="Avg Crop & Soil Health" />
                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 7 }}>
                                    {[
                                        ["Crop NDVI", pf(robots.reduce((s, r) => s + r.NDVI, 0) / 100), T.gr, "0-1"],
                                        ["Soil Moisture", Math.round(robots.reduce((s, r) => s + r.SM, 0) / 100), T.cy, "%"],
                                        ["Soil pH", pf(robots.reduce((s, r) => s + r.soilPH, 0) / 100), T.am, "avg"],
                                        ["Crop Health", Math.round(robots.reduce((s, r) => s + r.cropHealth, 0) / 100), T.gr, "/100"],
                                    ].map(([l, v, c, unit]) => (
                                        <div key={l} style={{ background: T.bg3, borderRadius: 5, padding: "8px 9px", border: `1px solid ${c}22`, textAlign: "center" }}>
                                            <div style={{ color: c, fontSize: 18, fontWeight: 700, lineHeight: 1 }}>{v}</div>
                                            <div style={{ color: T.txD, fontSize: 7.5, marginTop: 2 }}>{unit}</div>
                                            <div style={{ color: T.txD, fontSize: 7.5, marginTop: 1 }}>{l}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* ═══ CENTER: Map / Coverage / Panchang ═══ */}
                <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", background: T.bg0 }}>

                    {/* Center tab bar */}
                    <div style={{ display: "flex", alignItems: "center", gap: 0, borderBottom: `1px solid ${T.br}`, background: T.bg1, flexShrink: 0 }}>
                        {[{ k: "map", l: "🗺 Farm Map" }, { k: "coverage", l: "📊 Coverage" }, { k: "panchang", l: "🌙 Panchang Calendar" }].map(t => (
                            <button key={t.k} onClick={() => setMainTab(t.k)} style={{
                                background: mainTab === t.k ? T.bg2 : "transparent", border: "none",
                                borderBottom: `2px solid ${mainTab === t.k ? T.a : "transparent"}`,
                                color: mainTab === t.k ? T.a : T.txD, padding: "7px 14px", cursor: "pointer",
                                fontSize: 9.5, letterSpacing: "0.06em", transition: "all 0.15s", flexShrink: 0
                            }}>
                                {t.l}
                            </button>
                        ))}

                        {mainTab === "map" && <>
                            <div style={{ flex: 1 }} />
                            {/* Map layer switcher */}
                            {[["normal", "Normal"], ["coverage", "Coverage"], ["crop", "Crop NDVI"], ["soil", "Soil Moisture"]].map(([k, l]) => (
                                <button key={k} onClick={() => setMapLayer(k)} style={{
                                    background: mapLayer === k ? T.a2 : "transparent", border: `1px solid ${mapLayer === k ? T.a : T.brH + "44"}`,
                                    color: mapLayer === k ? T.a : T.txD, borderRadius: 3, padding: "3px 8px", cursor: "pointer",
                                    fontSize: 8.5, margin: "4px 3px", transition: "all 0.15s"
                                }}>{l}</button>
                            ))}
                            <button onClick={() => { setFocus(f => !f); if (focus) setSel(null); }} style={{
                                background: focus ? T.a2 : "transparent", border: `1px solid ${focus ? T.a : T.brH + "44"}`,
                                color: focus ? T.a : T.txD, borderRadius: 3, padding: "3px 8px", cursor: "pointer", fontSize: 8.5, margin: "4px 3px", transition: "all 0.15s"
                            }}>
                                FOCUS {focus ? "ON" : "OFF"}
                            </button>
                            <button onClick={() => { setBatch(b => !b); if (batch) setMsel(new Set()); }} style={{
                                background: batch ? T.cy2 : "transparent", border: `1px solid ${batch ? T.cy : T.brH + "44"}`,
                                color: batch ? T.cy : T.txD, borderRadius: 3, padding: "3px 8px", cursor: "pointer", fontSize: 8.5, margin: "4px 3px", transition: "all 0.15s"
                            }}>
                                MULTI-SEL {batch ? "ON" : "OFF"}
                            </button>
                        </>}
                    </div>

                    {batch && msel.size > 0 && mainTab === "map" && (
                        <div style={{
                            padding: "4px 10px", background: T.bg2, borderBottom: `1px solid ${T.br}`,
                            display: "flex", alignItems: "center", gap: 6, flexShrink: 0, flexWrap: "wrap"
                        }}>
                            <span style={{ color: T.cy, fontSize: 10, fontWeight: 700 }}>{msel.size} selected</span>
                            <div style={{ flex: 1 }} />
                            {[["CMD:F", () => { setRobots(p => p.map(r => msel.has(r.id) ? { ...r, CMD: "F", Speed: 8 } : r)); setMsel(new Set()); setBatch(false); }],
                            ["CMD:S", () => { setRobots(p => p.map(r => msel.has(r.id) ? { ...r, CMD: "S", Speed: 0 } : r)); setMsel(new Set()); setBatch(false); }],
                            ["GC ON", () => { setRobots(p => p.map(r => msel.has(r.id) ? { ...r, GC: 1, SP: 0, SO: 0, op: "GC" } : r)); setMsel(new Set()); setBatch(false); }],
                            ["SP ON", () => { setRobots(p => p.map(r => msel.has(r.id) ? { ...r, SP: 1, GC: 0, SO: 0, op: "SP" } : r)); setMsel(new Set()); setBatch(false); }],
                            ["SO ON", () => { setRobots(p => p.map(r => msel.has(r.id) ? { ...r, SO: 1, GC: 0, SP: 0, op: "SO" } : r)); setMsel(new Set()); setBatch(false); }],
                            ].map(([l, fn]) => (
                                <button key={l} onClick={fn} style={{
                                    background: T.a3, border: `1px solid ${T.a}`, color: T.a,
                                    borderRadius: 3, padding: "3px 9px", cursor: "pointer", fontSize: 9
                                }}>{l}</button>
                            ))}
                            <button onClick={() => { setMsel(new Set()); setBatch(false); }} style={{ background: "transparent", border: `1px solid ${T.txX}`, color: T.txD, borderRadius: 3, padding: "3px 7px", cursor: "pointer", fontSize: 9 }}>CLEAR</button>
                        </div>
                    )}

                    {/* MAP TAB */}
                    {mainTab === "map" && (
                        <div style={{ flex: 1, overflow: "hidden" }}>
                            <FarmMap robots={robots} coverage={coverage} sel={sel} msel={msel}
                                focus={focus} batch={batch} flash={flash} mapLayer={mapLayer}
                                onClick={doClick} zoneCov={zoneCov} />
                        </div>
                    )}

                    {/* COVERAGE TAB */}
                    {mainTab === "coverage" && (
                        <div style={{ flex: 1, overflow: "auto", padding: "14px 18px" }}>
                            <div style={{ color: T.a, fontSize: 12, fontWeight: 700, marginBottom: 14, letterSpacing: "0.1em" }}>
                                AREA COVERAGE ANALYSIS — LIVE
                            </div>

                            {/* Zone grid */}
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
                                {["A", "B", "C", "D"].map(z => {
                                    const gc = zoneCov[z].GC, sp = zoneCov[z].SP, so = zoneCov[z].SO;
                                    const overall = Math.round((gc + sp + so) / 3);
                                    return (
                                        <div key={z} style={{ background: T.bg2, borderRadius: 8, padding: "12px 14px", border: `1px solid ${T.br}` }}>
                                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                                                <div>
                                                    <div style={{ color: T.a, fontSize: 14, fontWeight: 700 }}>ZONE {z}</div>
                                                    <div style={{ color: T.txD, fontSize: 8.5, marginTop: 1 }}>
                                                        {z === "A" ? "GC + SO" : z === "B" ? "Spraying" : z === "C" ? "Sowing" : "GC"}
                                                    </div>
                                                </div>
                                                <Ring score={overall} size={44} label="COV" />
                                            </div>
                                            {[["GC", gc, T.ye, "Grass Cutting"], ["SP", sp, T.cy, "Spraying"], ["SO", so, T.gr, "Sowing"]].map(([op, v, c, hint]) => (
                                                <div key={op} style={{ marginBottom: 6 }}>
                                                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
                                                        <span style={{ color: T.txD, fontSize: 9 }}>{op} — {hint}</span>
                                                        <span style={{ color: c, fontSize: 10, fontWeight: 700 }}>{v}%</span>
                                                    </div>
                                                    <div style={{ height: 4, background: T.bg4, borderRadius: 2, overflow: "hidden" }}>
                                                        <div style={{ width: `${v}%`, height: "100%", background: c, transition: "width 1.2s", boxShadow: `0 0 6px ${c}50` }} />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    );
                                })}
                            </div>

                            {/* Robot-level coverage table */}
                            <div style={{ background: T.bg2, borderRadius: 8, border: `1px solid ${T.br}`, overflow: "hidden", marginBottom: 16 }}>
                                <div style={{ padding: "9px 14px", borderBottom: `1px solid ${T.br}`, color: T.a, fontSize: 10, fontWeight: 600, letterSpacing: "0.1em" }}>
                                    ROBOT LEVEL COVERAGE — TOP 15
                                </div>
                                <div style={{ maxHeight: 200, overflowY: "auto" }}>
                                    {[...robots].sort((a, b) => b.covArea - a.covArea).slice(0, 15).map(r => {
                                        const opK = r.GC ? "GC" : r.SP ? "SP" : r.SO ? "SO" : "IDLE";
                                        const c = { GC: T.ye, SP: T.cy, SO: T.gr, IDLE: T.txD }[opK];
                                        return (
                                            <div key={r.id} onClick={() => setSel(r.id)} style={{
                                                display: "flex", alignItems: "center", gap: 10, padding: "6px 14px",
                                                borderBottom: `1px solid ${T.bg3}`, cursor: "pointer", transition: "background 0.12s"
                                            }}
                                                onMouseEnter={e => e.currentTarget.style.background = T.bg3}
                                                onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                                                <div style={{ width: 7, height: 7, borderRadius: "50%", background: c, flexShrink: 0 }} />
                                                <span style={{ color: T.txL, fontSize: 10, minWidth: 38 }}>{r.FID}</span>
                                                <span style={{ color: c, fontSize: 9, minWidth: 20 }}>{opK}</span>
                                                <span style={{ color: T.txD, fontSize: 9 }}>Zone {r.zone}</span>
                                                <div style={{ flex: 1, height: 3, background: T.bg4, borderRadius: 2, overflow: "hidden" }}>
                                                    <div style={{ width: `${Math.min(r.covArea / 100, 100)}%`, height: "100%", background: c, opacity: 0.7 }} />
                                                </div>
                                                <span style={{ color: c, fontSize: 10, fontWeight: 700, minWidth: 50, textAlign: "right" }}>{r.covArea} m²</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* Plant level summary */}
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
                                {[
                                    { label: "Plants Sowed", val: Math.round(stats.so * 800), color: T.gr, icon: "🌱", unit: "plants" },
                                    { label: "Area Sprayed", val: Math.round(stats.sp * 1200), color: T.cy, icon: "💧", unit: "m²" },
                                    { label: "Grass Cut", val: Math.round(stats.gc * 900), color: T.ye, icon: "✂", unit: "m²" },
                                ].map(s => (
                                    <div key={s.label} style={{
                                        background: T.bg2, borderRadius: 8, padding: "12px 14px",
                                        border: `1px solid ${s.color}22`, textAlign: "center"
                                    }}>
                                        <div style={{ fontSize: 22, marginBottom: 4 }}>{s.icon}</div>
                                        <div style={{ color: s.color, fontSize: 20, fontWeight: 700, lineHeight: 1 }}>{s.val.toLocaleString()}</div>
                                        <div style={{ color: T.txD, fontSize: 8, marginTop: 2 }}>{s.unit}</div>
                                        <div style={{ color: T.txD, fontSize: 8, marginTop: 1 }}>{s.label}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* PANCHANG CALENDAR TAB */}
                    {mainTab === "panchang" && (
                        <div style={{ flex: 1, overflow: "auto", padding: "14px 16px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                                <MoonSVG phase={panchang.moonPhase} size={52} />
                                <div>
                                    <div style={{ color: T.pu, fontSize: 14, fontWeight: 700, letterSpacing: "0.06em" }}>VEDIC PANCHANG MISSION INTELLIGENCE</div>
                                    <div style={{ color: T.txD, fontSize: 9.5, marginTop: 2 }}>{now.toDateString()} · {panchang.vara} · Lord: {panchang.varaLord}</div>
                                </div>
                            </div>

                            {/* Today's full panchang */}
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 14 }}>
                                {[
                                    { label: "Tithi", val: panchang.tithiName, sub: `Day ${panchang.tithiNum + 1} of lunar month`, color: T.cy },
                                    { label: "Paksha", val: panchang.paksha.split(" ")[0] + " " + panchang.paksha.split(" ")[1], sub: panchang.tithiNum < 15 ? "Waxing Moon" : "Waning Moon", color: T.tx },
                                    { label: "Nakshatra", val: panchang.nakshatra.name, sub: `Lord: ${panchang.nakshatra.lord} · ${panchang.nakshatra.type}`, color: T.pu },
                                    { label: "Yoga", val: panchang.yoga.name, sub: panchang.yoga.desc, color: yogaC },
                                    { label: "Karana", val: panchang.karana, sub: "Half-tithi period", color: T.am },
                                    { label: "Vara", val: panchang.vara, sub: `Planetary lord: ${panchang.varaLord}`, color: T.cy },
                                ].map(f => (
                                    <div key={f.label} style={{ background: T.bg2, borderRadius: 6, padding: "9px 11px", border: `1px solid ${f.color}22` }}>
                                        <div style={{ color: T.txD, fontSize: 8.5, marginBottom: 3, letterSpacing: "0.1em" }}>{f.label}</div>
                                        <div style={{ color: f.color, fontSize: 12, fontWeight: 700 }}>{f.val}</div>
                                        <div style={{ color: T.txD, fontSize: 8.5, marginTop: 2 }}>{f.sub}</div>
                                    </div>
                                ))}
                            </div>

                            {/* Farm recommendation panel */}
                            <div style={{
                                background: `${T.bg2}`, borderRadius: 8, padding: "12px 14px",
                                border: `1px solid ${yogaC}30`, marginBottom: 14
                            }}>
                                <div style={{ color: yogaC, fontSize: 10.5, fontWeight: 700, marginBottom: 8, letterSpacing: "0.08em" }}>
                                    TODAY'S MISSION INTELLIGENCE — {panchang.yoga.name.toUpperCase()} YOGA
                                </div>
                                <div style={{ color: T.txL, fontSize: 10, lineHeight: 1.7, marginBottom: 8 }}>
                                    <span style={{ color: T.pu, fontWeight: 600 }}>Nakshatra:</span> {panchang.nakshatra.name} — {panchang.nakshatra.farm}
                                </div>
                                <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
                                    {[
                                        { op: "SO", label: "Sowing", score: panchang.soScore, color: T.gr },
                                        { op: "SP", label: "Spraying", score: panchang.spScore, color: T.cy },
                                        { op: "GC", label: "Grass Cut", score: panchang.gcScore, color: T.ye },
                                    ].map(m => (
                                        <div key={m.op} style={{
                                            flex: 1, background: T.bg3, borderRadius: 6, padding: "9px",
                                            border: `1px solid ${m.color}${m.score > 70 ? "55" : "22"}`, textAlign: "center"
                                        }}>
                                            <div style={{ color: m.color, fontSize: 18, fontWeight: 700, lineHeight: 1 }}>{m.score}</div>
                                            <div style={{ color: T.txD, fontSize: 8, marginTop: 1 }}>/100</div>
                                            <div style={{ color: m.score > 70 ? m.color : T.txD, fontSize: 9, marginTop: 4, fontWeight: m.score > 70 ? 700 : 400 }}>
                                                {m.label}
                                            </div>
                                            <div style={{ color: T.txD, fontSize: 7.5, marginTop: 1 }}>
                                                {m.score >= 85 ? "★ BEST" : m.score >= 70 ? "✓ Good" : m.score >= 50 ? "~ Moderate" : "✗ Avoid"}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                {panchang.windows.length > 0 && (
                                    <div>
                                        <div style={{ color: T.txD, fontSize: 8.5, marginBottom: 5, letterSpacing: "0.1em" }}>AUSPICIOUS WINDOWS TODAY</div>
                                        {panchang.windows.map((w, i) => (
                                            <div key={i} style={{
                                                display: "flex", alignItems: "center", gap: 8, padding: "5px 8px",
                                                background: T.bg3, borderRadius: 4, marginBottom: 4, border: `1px solid ${w.color}30`
                                            }}>
                                                <div style={{ width: 6, height: 6, borderRadius: "50%", background: w.color }} />
                                                <span style={{ color: w.color, fontSize: 10, fontWeight: 600, minWidth: 40 }}>{w.op}</span>
                                                <span style={{ color: T.txL, fontSize: 10 }}>{w.label}</span>
                                                <div style={{ flex: 1 }} />
                                                <span style={{ color: T.txD, fontSize: 9 }}>{w.from} – {w.to}</span>
                                                <span style={{ color: w.color, fontSize: 9, fontWeight: 700 }}>Score {w.score}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* 7-day calendar */}
                            <div style={{ color: T.a, fontSize: 10, fontWeight: 600, marginBottom: 9, letterSpacing: "0.1em" }}>
                                7-DAY VEDIC MISSION CALENDAR
                            </div>
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: 6, marginBottom: 16 }}>
                                {weekCal.map(({ date: d, panchang: p }, i) => {
                                    const isToday = d.toDateString() === now.toDateString();
                                    const best = p.soScore > 75 || p.spScore > 75 || p.gcScore > 75;
                                    const bad = p.yoga.type === "bad";
                                    const bdr = isToday ? T.a : best ? T.gr : bad ? T.rd : T.txX;
                                    return (
                                        <div key={i} style={{
                                            background: T.bg2, borderRadius: 6, padding: "7px 5px",
                                            border: `1px solid ${bdr}${isToday ? "" : bad ? "50" : "30"}`,
                                            textAlign: "center", position: "relative"
                                        }}>
                                            {isToday && <div style={{
                                                position: "absolute", top: 2, right: 4, width: 5, height: 5, borderRadius: "50%",
                                                background: T.a, boxShadow: `0 0 5px ${T.a}`
                                            }} />}
                                            <div style={{ color: isToday ? T.a : T.txL, fontSize: 9.5, fontWeight: isToday ? 700 : 400 }}>
                                                {d.toLocaleDateString("en", { weekday: "short" })}
                                            </div>
                                            <div style={{ color: T.txD, fontSize: 8.5, marginTop: 1 }}>{d.getDate()}/{d.getMonth() + 1}</div>
                                            <div style={{ color: T.pu, fontSize: 7.5, marginTop: 3, lineHeight: 1.3 }}>{p.nakshatra.name.slice(0, 7)}</div>
                                            <div style={{ marginTop: 5, display: "flex", justifyContent: "center", gap: 2, flexWrap: "wrap" }}>
                                                {p.soScore > 75 && <div style={{ width: 5, height: 5, borderRadius: "50%", background: T.gr }} title="Good SO" />}
                                                {p.spScore > 75 && <div style={{ width: 5, height: 5, borderRadius: "50%", background: T.cy }} title="Good SP" />}
                                                {p.gcScore > 75 && <div style={{ width: 5, height: 5, borderRadius: "50%", background: T.ye }} title="Good GC" />}
                                                {bad && <div style={{ width: 5, height: 5, borderRadius: "50%", background: T.rd }} title="Bad yoga" />}
                                            </div>
                                            <div style={{ color: bad ? T.rd : best ? T.gr : T.txD, fontSize: 7, marginTop: 3 }}>
                                                {bad ? "Caution" : best ? "Favorable" : "Moderate"}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            {/* Nakshatra guide */}
                            <div style={{ color: T.a, fontSize: 10, fontWeight: 600, marginBottom: 9, letterSpacing: "0.1em" }}>NAKSHATRA QUICK GUIDE</div>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 5 }}>
                                {NAKSHATRAS.filter(n => n.farm.includes("★")).map(n => (
                                    <div key={n.name} style={{ background: T.bg2, borderRadius: 5, padding: "7px 9px", border: `1px solid ${T.gr}30` }}>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <span style={{ color: T.gr, fontSize: 10, fontWeight: 600 }}>{n.name}</span>
                                            <span style={{ color: T.txD, fontSize: 8 }}>{n.lord}</span>
                                        </div>
                                        <div style={{ color: T.txD, fontSize: 8, marginTop: 2 }}>{n.farm}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                {/* ═══ RIGHT PANEL: Robot Detail ═══ */}
                <div style={{
                    width: 288, display: "flex", flexDirection: "column", borderLeft: `1px solid ${T.br}`,
                    overflow: "hidden", background: T.bg1, flexShrink: 0
                }}>
                    {!robot ? (
                        <div style={{ flex: 1, overflowY: "auto", padding: "12px 12px" }}>
                            <SecH label="Fleet Overview" />
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 7, marginBottom: 12 }}>
                                {[[stats.gc, "GC Active", T.ye], [stats.sp, "SP Active", T.cy], [stats.so, "SO Active", T.gr]].map(([v, l, c]) => (
                                    <div key={l} style={{ background: T.bg3, borderRadius: 5, padding: "8px 6px", textAlign: "center", border: `1px solid ${c}22` }}>
                                        <div style={{ color: c, fontSize: 20, fontWeight: 700, lineHeight: 1 }}>{v}</div>
                                        <div style={{ color: T.txD, fontSize: 7.5, marginTop: 2, textTransform: "uppercase" }}>{l}</div>
                                    </div>
                                ))}
                            </div>

                            <SecH label="Predictive Battery Watch" />
                            {robots.filter(r => predictBat(r).mins < 20 && r.op !== "IDLE").slice(0, 5).map(r => {
                                const p = predictBat(r);
                                return (
                                    <div key={r.id} onClick={() => setSel(r.id)} style={{
                                        display: "flex", alignItems: "center", gap: 7, padding: "5px 7px", marginBottom: 3,
                                        background: T.bg3, borderRadius: 4, border: `1px solid ${T.am}25`, cursor: "pointer"
                                    }}
                                        onMouseEnter={e => e.currentTarget.style.borderColor = T.am}
                                        onMouseLeave={e => e.currentTarget.style.borderColor = `${T.am}25`}>
                                        <div style={{ color: T.am, fontSize: 10 }}>⚡</div>
                                        <div style={{ flex: 1 }}>
                                            <div style={{ color: T.tx, fontSize: 10, fontWeight: 600 }}>{r.FID} <span style={{ color: T.txD, fontSize: 8.5 }}>Zone{r.zone}</span></div>
                                            <div style={{ color: T.am, fontSize: 8 }}>~{p.mins}min — CB:{Math.round(r.CB)}% MB:{Math.round(r.MB)}%</div>
                                        </div>
                                    </div>
                                );
                            })}

                            <SecH label="Today's Panchang Advice" />
                            <div style={{ background: `${T.bg3}`, borderRadius: 6, padding: "9px 10px", border: `1px solid ${T.pu}25` }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                                    <MoonSVG phase={panchang.moonPhase} size={28} />
                                    <div>
                                        <div style={{ color: T.pu, fontSize: 10.5, fontWeight: 700 }}>{panchang.nakshatra.name}</div>
                                        <div style={{ color: T.txD, fontSize: 8.5 }}>{panchang.tithiName}</div>
                                    </div>
                                </div>
                                <div style={{ color: T.txD, fontSize: 9, lineHeight: 1.6 }}>{panchang.nakshatra.farm}</div>
                                <div style={{ marginTop: 7, display: "flex", gap: 5, justifyContent: "space-between" }}>
                                    <PanchScore score={panchang.soScore} label="Sow" color={T.gr} />
                                    <PanchScore score={panchang.spScore} label="Spray" color={T.cy} />
                                    <PanchScore score={panchang.gcScore} label="Cut" color={T.ye} />
                                </div>
                            </div>
                        </div>
                    ) : (() => {
                        const opK = robot.GC ? "GC" : robot.SP ? "SP" : robot.SO ? "SO" : robot.op === "ERR" ? "ERR" : robot.op === "RTB" ? "RTB" : "IDLE";
                        const opC = { GC: T.ye, SP: T.cy, SO: T.gr, ERR: T.rd, RTB: T.or, IDLE: T.txD }[opK] || T.txD;
                        const pred = predictBat(robot);
                        return (
                            <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
                                <div style={{ padding: "10px 12px", borderBottom: `1px solid ${T.br}`, background: T.bg2, flexShrink: 0 }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 8 }}>
                                        <Ring score={rh} size={50} />
                                        <div style={{ flex: 1 }}>
                                            <div style={{ color: T.tx, fontSize: 15, fontWeight: 700, lineHeight: 1 }}>{robot.FID}</div>
                                            <div style={{ color: opC, fontSize: 10, marginTop: 3, animation: opK === "ERR" ? "blink 1s infinite" : undefined }}>
                                                {opK === "ERR" && flash ? "⚠ " : ""}{opK}
                                            </div>
                                        </div>
                                        <div style={{ textAlign: "right" }}>
                                            <SigBars sig={robot.sig} />
                                            <div style={{ color: T.txD, fontSize: 8, marginTop: 3 }}>{Math.floor((now - robot.upd) / 1000)}s ago</div>
                                        </div>
                                    </div>
                                    {/* Op badges */}
                                    <div style={{ display: "flex", gap: 4, marginBottom: pred.mins < 25 ? 7 : 0 }}>
                                        {[["GC", T.ye], ["SP", T.cy], ["SO", T.gr]].map(([op, c]) => (
                                            <div key={op} style={{
                                                background: robot[op] ? `${c}18` : T.bg4, border: `1px solid ${robot[op] ? c : T.txX}`,
                                                borderRadius: 4, padding: "2px 7px", flex: 1, textAlign: "center"
                                            }}>
                                                <span style={{ color: robot[op] ? c : T.txD, fontSize: 9, fontWeight: robot[op] ? 700 : 400 }}>{op}:{robot[op]}</span>
                                            </div>
                                        ))}
                                    </div>
                                    {pred.mins < 25 && opK !== "IDLE" && (
                                        <div style={{ background: `${T.am}10`, border: `1px solid ${T.am}40`, borderRadius: 4, padding: "4px 8px" }}>
                                            <div style={{ color: T.am, fontSize: 9, fontWeight: 700 }}>⚡ Battery critical ~{pred.mins}min</div>
                                        </div>
                                    )}
                                </div>

                                {/* Tabs */}
                                <div style={{ display: "flex", borderBottom: `1px solid ${T.br}`, flexShrink: 0 }}>
                                    {["telemetry", "hardware", "commands"].map(t => (
                                        <button key={t} onClick={() => setRtab(t)} style={{
                                            flex: 1, background: rtab === t ? T.bg3 : "transparent", border: "none",
                                            borderBottom: `2px solid ${rtab === t ? T.a : "transparent"}`,
                                            color: rtab === t ? T.a : T.txD, padding: "6px 0", cursor: "pointer",
                                            fontSize: 8.5, textTransform: "uppercase", letterSpacing: "0.06em", transition: "all 0.15s"
                                        }}>
                                            {t}
                                        </button>
                                    ))}
                                </div>

                                <div style={{ flex: 1, overflowY: "auto", padding: "10px 12px" }}>

                                    {rtab === "telemetry" && (
                                        <>
                                            <SecH label="BATTERIES" />
                                            <BatBar pct={robot.CB} color={T.a} label="CB Controller" warn={pred.mins < 30 ? pred.mins : null} />
                                            <BatBar pct={robot.MB} color={T.cy} label="MB Motor" warn={pred.mins < 30 ? pred.mins : null} />
                                            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4, marginBottom: 10 }}>
                                                <span style={{ color: T.txD, fontSize: 8.5 }}>CB Trend</span>
                                                <Spark data={robot.cbHist} color={robot.CB < 25 ? T.rd : T.a} />
                                            </div>
                                            <SecH label="MOTION" />
                                            <DRow label="CMD" val={`"${robot.CMD}"`} color={robot.CMD === "F" ? T.gr : robot.CMD === "B" ? T.am : T.txD} />
                                            <DRow label="TURN" val={`"${robot.TURN}"`} color={robot.TURN !== "N" ? T.cy : undefined} />
                                            <DRow label="Speed" val={`${robot.Speed.toFixed(1)} km/h`} />
                                            <SecH label="CROP & SOIL" />
                                            <DRow label="NDVI (Crop Health)" val={robot.NDVI.toFixed(2)} color={robot.NDVI > 0.6 ? T.gr : robot.NDVI > 0.4 ? T.am : T.rd} sub={robot.NDVI > 0.6 ? "Healthy" : robot.NDVI > 0.4 ? "Stressed" : "Poor"} />
                                            <DRow label="Soil Moisture (SM)" val={`${robot.SM}%`} color={robot.SM < 25 ? T.rd : robot.SM > 70 ? T.am : T.a} />
                                            <DRow label="Soil pH (SP)" val={robot.soilPH.toFixed(1)} color={(robot.soilPH < 5.5 || robot.soilPH > 8) ? T.am : undefined} />
                                            <DRow label="Crop Health Score" val={`${robot.cropHealth}/100`} color={robot.cropHealth > 70 ? T.gr : robot.cropHealth > 50 ? T.am : T.rd} />
                                            <DRow label="Soil Health" val={`${robot.soilHealth}/100`} color={robot.soilHealth > 70 ? T.gr : T.am} />
                                            <SecH label="GPS" />
                                            <DRow label="GPS Status" val={robot.GPS_OK ? "LOCKED" : "FAULT"} color={robot.GPS_OK ? T.gr : T.rd} />
                                            <DRow label="Accuracy" val={`±${robot.gpsAcc.toFixed(1)}m`} color={robot.gpsAcc > 2 ? T.am : undefined} />
                                            <DRow label="Satellites" val={robot.gpsSats} />
                                            <DRow label="Lat/Lng" val={`${robot.lat.toFixed(4)}, ${robot.lng.toFixed(4)}`} />
                                        </>
                                    )}

                                    {rtab === "hardware" && (
                                        <>
                                            <SecH label="MOTORS" />
                                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6, marginBottom: 12 }}>
                                                <LED ok={robot.MOT_L} label="Left Motor" />
                                                <LED ok={robot.MOT_R} label="Right Motor" />
                                            </div>
                                            <SecH label="OPERATION SYSTEMS" />
                                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6, marginBottom: 12 }}>
                                                <LED ok={robot.BLADE_OK} label="GC Blade" />
                                                <LED ok={robot.PUMP_OK} label="SP Pump" />
                                                <LED ok={robot.SEED_OK} label="SO Seed Mech" />
                                                <LED ok={robot.SOIL_SENS} label="Soil Sensor" />
                                            </div>
                                            <SecH label="CONNECTIVITY" />
                                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6, marginBottom: 12 }}>
                                                <LED ok={robot.GPS_OK} label="GPS Lock" />
                                                <LED ok={robot.CAM_OK} label="Camera" />
                                            </div>
                                            <SecH label="CAMERA" />
                                            <div style={{
                                                background: T.bg0, borderRadius: 5, aspectRatio: "16/9",
                                                display: "flex", alignItems: "center", justifyContent: "center",
                                                border: `1px solid ${robot.CAM_OK ? T.br : T.rd + "40"}`, marginBottom: 10
                                            }}>
                                                {robot.CAM_OK ? (
                                                    <div style={{ textAlign: "center" }}>
                                                        <div style={{ color: T.a, fontSize: 11, marginBottom: 4 }}>📷 LIVE FEED</div>
                                                        {/* Simulated camera grid */}
                                                        <svg width="100" height="56">
                                                            {Array.from({ length: 8 }, (_, i) => Array.from({ length: 5 }, (_, j) => (
                                                                <rect key={`${i}${j}`} x={i * 12 + 2} y={j * 10 + 2} width="11" height="9" rx="1"
                                                                    fill={`rgba(${rndI(0, 80)},${rndI(80, 160)},${rndI(0, 60)},0.6)`} />
                                                            )))}
                                                            <text x="50" y="50" textAnchor="middle" style={{ fill: "rgba(0,229,160,0.6)", fontSize: "7px", fontFamily: "monospace" }}>{robot.FID} LIVE</text>
                                                        </svg>
                                                    </div>
                                                ) : (
                                                    <div style={{ color: T.rd, fontSize: 10, textAlign: "center" }}>
                                                        <div style={{ fontSize: 20, marginBottom: 4 }}>📷</div>
                                                        CAMERA FAULT
                                                    </div>
                                                )}
                                            </div>
                                            <SecH label="FAULT SUMMARY" />
                                            <div style={{ background: T.bg3, borderRadius: 5, padding: "8px 9px" }}>
                                                {[["MOT_L", "Left Motor"], ["MOT_R", "Right Motor"], ["GPS_OK", "GPS"], ["CAM_OK", "Camera"], ["BLADE_OK", "GC Blade"], ["PUMP_OK", "SP Pump"], ["SEED_OK", "SO Mechanism"]].map(([k, l]) => (
                                                    <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "3px 0", borderBottom: `1px solid ${T.bg4}` }}>
                                                        <span style={{ color: T.txD, fontSize: 9.5 }}>{l}</span>
                                                        <span style={{ color: robot[k] ? T.gr : T.rd, fontSize: 9.5, fontWeight: 700 }}>{robot[k] ? "OK" : "FAULT"}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    )}

                                    {rtab === "commands" && (
                                        <>
                                            <SecH label="MOTION" />
                                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 5, marginBottom: 10 }}>
                                                {[["▲ FWD", "F", T.gr], ["▼ BACK", "B", T.am], ["■ STOP", "S", T.rd]].map(([l, v, c]) => (
                                                    <button key={v} onClick={() => sendCmd("CMD", v)}
                                                        style={{
                                                            background: robot.CMD === v ? `${c}20` : T.bg3, border: `1px solid ${robot.CMD === v ? c : T.txX}`,
                                                            color: robot.CMD === v ? c : T.txD, borderRadius: 4, padding: "8px 4px", cursor: "pointer",
                                                            fontSize: 10, fontWeight: robot.CMD === v ? 700 : 400, transition: "all 0.15s"
                                                        }}>
                                                        <div style={{ fontWeight: 700 }}>{l}</div>
                                                        <div style={{ fontSize: 8, opacity: 0.7 }}>CMD:{v}</div>
                                                    </button>
                                                ))}
                                            </div>
                                            <SecH label="TURN" />
                                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 5, marginBottom: 10 }}>
                                                {[["◀ L", "L", T.cy], ["● STR", "N", T.txD], ["▶ R", "R", T.cy]].map(([l, v, c]) => (
                                                    <button key={v} onClick={() => sendCmd("TURN", v)}
                                                        style={{
                                                            background: robot.TURN === v ? `${c}18` : T.bg3, border: `1px solid ${robot.TURN === v ? c : T.txX}`,
                                                            color: robot.TURN === v ? c : T.txD, borderRadius: 4, padding: "7px 4px", cursor: "pointer",
                                                            fontSize: 10, transition: "all 0.15s"
                                                        }}>
                                                        {l}
                                                    </button>
                                                ))}
                                            </div>
                                            <SecH label="OPERATIONS" />
                                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 5, marginBottom: 10 }}>
                                                {[["GC", T.ye], ["SP", T.cy], ["SO", T.gr]].map(([op, c]) => (
                                                    <button key={op} onClick={() => sendCmd(op, robot[op] ? 0 : 1)}
                                                        style={{
                                                            background: robot[op] ? `${c}20` : T.bg3, border: `1px solid ${robot[op] ? c : T.txX}`,
                                                            color: robot[op] ? c : T.txD, borderRadius: 4, padding: "8px 4px", cursor: "pointer",
                                                            fontSize: 10, fontWeight: robot[op] ? 700 : 400, transition: "all 0.15s", textAlign: "center"
                                                        }}>
                                                        <div style={{ fontWeight: 700 }}>{op}</div>
                                                        <div style={{ fontSize: 8, opacity: 0.7 }}>{robot[op] ? "ACTIVE" : "OFF"}</div>
                                                    </button>
                                                ))}
                                            </div>
                                            <SecH label="SPEED" />
                                            <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 10 }}>
                                                <input type="range" min="0" max="20" value={Math.round(robot.Speed)}
                                                    onChange={e => sendCmd("Speed", parseInt(e.target.value))}
                                                    style={{ flex: 1, accentColor: T.a }} />
                                                <span style={{ color: T.a, fontSize: 11, fontWeight: 700, minWidth: 44 }}>{Math.round(robot.Speed)} km/h</span>
                                            </div>
                                            {cmdSent && (
                                                <div style={{
                                                    background: `${T.a}10`, border: `1px solid ${T.a}38`, borderRadius: 4, padding: "6px 8px",
                                                    fontSize: 9.5, color: T.a, animation: "fadeIn 0.3s ease"
                                                }}>
                                                    ✓ Command sent → {robot.FID} confirmed {ts()}
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>

                                <div style={{ padding: "7px 12px", borderTop: `1px solid ${T.br}`, flexShrink: 0 }}>
                                    <button onClick={() => { setSel(null); setFocus(false); }} style={{
                                        background: "transparent", border: `1px solid ${T.txX}`, color: T.txD,
                                        borderRadius: 4, padding: "5px 0", cursor: "pointer", fontSize: 10, width: "100%", transition: "all 0.15s"
                                    }}
                                        onMouseEnter={e => { e.currentTarget.style.borderColor = T.txD; e.currentTarget.style.color = T.tx; }}
                                        onMouseLeave={e => { e.currentTarget.style.borderColor = T.txX; e.currentTarget.style.color = T.txD; }}>
                                        ← Fleet Overview
                                    </button>
                                </div>
                            </div>
                        );
                    })()}
                </div>
            </div>
        </div>
    );
}
export default AgriCommandCenterV2;